import * as types from '../config/actionTypes';

const BillingActions = {
	readData: (data) => ({ type: types.READ_EXCHANGE_BILLING, data }),
	setNewInvoice: (data) => ({ type: types.SET_NEW_PAY, data }),
	setDiscountedPercentage:(data) => ({ type: types.SET_DISCOUNTED_PERCENTAGE,data}),
	setUpdatedPlugin:(data) => ({type: types.SET_UPDATED_PLUGIN,data}),
	setSelectedpluginDetail: (data) => ({type: types.SET_SELECTED_PLUGIN,data}),
};

export default BillingActions;
